import {
  type BusinessDivisionType,
  getDivisionContext,
  getNavigationContext,
  getPageContext,
  getShopContext,
  trackNavigationEvent,
  trackUserInteractionEvent,
  type UserActionEnum,
} from '@ev-tech/snowplow-library';

import { getConsentContext, useSearchModuleTracking } from './useSearchModuleTracking';
import { useAppContext } from './useAppContext';
import { useSearchStore } from './stores/search/useSearchStore';
import { PageType, TemplateType } from '../types/tracking';
import { useMapVisibilityStore } from '../providers/MapVisibilityStoreProvider';

export const useLipaPortfolioTrackButtonClick = ({
  elementId,
  targetUrl,
  action,
}: {
  elementId: string;
  targetUrl?: string;
  action: UserActionEnum;
}) => {
  const { tracking } = useAppContext();
  const {
    options: { language },
    countryCode,
  } = useAppContext();
  const shopIds = useSearchStore((state) => state.shopIds);
  const masterDataShopIds = useSearchStore((state) => state.masterDataShopIds);
  const masterDataLiPaIds = useSearchStore((state) => state.masterDataLiPaIds);
  const businessArea = useSearchStore((state) => state.objectTypeCategory);
  const isMapToggledOn = useMapVisibilityStore((state) => state.isMapActive);
  const { mapABTestContext } = useSearchModuleTracking();

  function trackButtonClick() {
    trackUserInteractionEvent({
      action: action,
      elementId: elementId,
      contexts: [
        getShopContext({ id: masterDataShopIds?.[0] }),
        getPageContext({
          type: tracking?.pageType ?? PageType.LIPA_SEARCH_RESULT,
          isHQPage: true,
        }),
        getDivisionContext({
          name: businessArea as BusinessDivisionType,
        }),
        mapABTestContext(isMapToggledOn),
      ],
    });
    trackNavigationEvent({
      screenName: '',
      contexts: [
        getPageContext({
          type: PageType.LIPA_SEARCH_RESULT,
          country_code: countryCode,
          page_language: language,
          template_type: TemplateType.SEARCH_RESULT,
          isHQPage: true,
        }),
        getNavigationContext({
          target_url: targetUrl ?? '',
          element_id: elementId,
          target_screen: '',
          source_screen: '',
        }),
        getShopContext({
          id: shopIds?.[0],
          shop_id: masterDataShopIds?.[0],
          license_id: masterDataLiPaIds?.[0],
          business_division_name: businessArea,
        }),
        getConsentContext(),
        mapABTestContext(isMapToggledOn),
      ],
    });
  }
  return { trackButtonClick };
};
